<template>
    <div class="modal-content">
        <div class="modal-header text-center">
            <modal-close v-if="consentDetails.requiredSave" />
            <div class="modal-title">
                <h2 class="h3 px-2 pt-3 pb-1">
                    {{ consentDetails.title }}
                </h2>
            </div>
        </div>
        <div class="modal-body pr-4 pl-4 consents-modal__body">
            <div v-if="!hideConsentDetails" class="text-sm mb-4">
                {{ consentDetails.consentDetails }}
            </div>
            <div class="tr-data mb-3 is-column">
                <consent-row :consents="consents" mode="modal" />
            </div>
            <div v-if="consentCode === 'EP'" class="mb-2 consents-modal__body__bottom-info">
                Uzupełniając powyższe dane oświadczam, że jestem uprawniony aby
                dysponować numerem telefonu oraz adresem e-mail przeze mnie
                podanym. Administratorem Pani/Pana danych osobowych jest
                Innowacyjna Platforma Handlu sp. z o.o. , z siedzibą w
                Komornikach przy ul. Wiśniowa 11. Pani/Pana dane osobowe będą
                przetwarzane w celu kierowania do Pani/Pana treści
                marketingowych wybranym kanałem komunikacji w związku z wyrażoną
                zgodą. W każdej chwili można cofnąć udzieloną zgodę poprzez
                przesłanie wiadomości na iod_iph@eurocash.pl Więcej informacji
                na temat przetwarzania danych osobowych, w tym o przysługujących
                Pani / Panu prawach, znajduje się w naszej
                <span
                    class="cursor-pointer"
                    @click.prevent="
                        $store.dispatch('openModal', {
                            component: 'ModalCookies'
                        })
                    "
                >
                    Polityce Prywatności
                </span>.
            </div>
            <div v-else>
                Zgodę możesz w każdej chwili wycofać w sekcji Zgody.
                Wystarczy, że klikniesz w pole przy danej zgodzie i zaznaczysz zmiany.
            </div>
        </div>
        <div class="modal-footer modal-footer__btnWide flex-nowrap gap-1">
            <the-btn
                v-if="consentDetails.requiredSave"
                @click.native="$store.dispatch('toggleModal', false)"
                text="Zamknij"
                btn-class="btn-outline-custom btn-primary"
            />
            <the-btn
                @click.native="onConsenstSave"
                text="Zapisz"
                btn-class="btn-secondary"
            />
        </div>
    </div>
</template>

<script>
import ConsentRow from '@/components/settings/ConsentRow'
import ConsentsSaveNotificationVue from '../consents/ConsentsSaveNotification.vue'

export default {
    components: { ConsentRow },
    props: {
        closeAfterSuccess: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        consents() {
            return this.consentCode === 'ECSP'
                ? this.$store.getters.getMarketingECSPConsents
                : this.$store.getters.getMarketingConsents
        },
        consentDetails() {
            return this.$store.getters.getMarketingDetails(this.consentCode)
        },
        consentCode() {
            return this.$store.getters.modalState.args.consentCode
        },
        hideConsentDetails() {
            return this.$store.getters.modalState.args.hideConsentDetails
        }
    },
    methods: {
        async onConsenstSave() {
            await this.$store.dispatch('saveMarketingConsents', {
                consentCode: this.consentCode
            })

            if (this.closeAfterSuccess) {
                await this.$store.dispatch('toggleModal', false)
            }

            this.$store.dispatch('addNotification', {
                type: 'success',
                content: {
                    type: 'component',
                    component: ConsentsSaveNotificationVue
                }
            })
            this.$emit('accept')
        }
    }
}
</script>
